import { LabelMapping } from './types';

export const LABEL_MAPPING: LabelMapping = {
  itemsSold: 'Items Sold',
  timesSold: 'Times Sold',
  totalTimesSold: 'Times Sold',
  totalItemsSold: 'Items Sold',
  numberOfCustomers: 'Number of Customers',
  totalRevenue: 'Revenue',
  revenue: 'Revenue',
  sales: 'Sales',
  orders: 'Orders',
  customers: 'Customers',
};

export const NUMBER_FORMAT_KEYS = [
  'itemsSold',
  'totalTimesSold',
  'totalItemsSold',
  'timesSold',
  'numberOfCustomers',
  'orders',
  'customers',
];

export const DEFAULT_CHART_HEIGHT = 300;
export const MOBILE_CHART_HEIGHT = 300;
